import type { Movie } from '@/types/movie';
import MovieCard from '@/components/base/MovieCard';

interface RatingRankingProps {
  movies: Movie[];
}

export default function RatingRanking({ movies }: RatingRankingProps) {
  return (
    <div className="mt-16 w-full bg-background-100 py-12 md:mt-20 md:py-14">
      <div className="mx-auto w-full max-w-[1440px] px-4 md:px-8">
        <div className="mb-7 flex flex-wrap items-end justify-between gap-3">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="h-5 w-1 rounded-full bg-accent-500" />
              <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">口碑高分榜</h2>
              <span className="mt-1 font-label text-xs uppercase tracking-[0.22em] text-foreground-400">
                Top Rated
              </span>
            </div>
            <p className="mt-2 text-sm text-foreground-500">近三年评分最高的十部作品，按观众口碑排序</p>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-foreground-400">
            <i className="ri-award-line text-accent-500" />
            数据为演示评分
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-4 xl:grid-cols-5">
          {movies.map((movie, index) => (
            <MovieCard key={movie.id} movie={movie} rank={index + 1} />
          ))}
        </div>
      </div>
    </div>
  );
}